import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import moment from 'moment-timezone';

//Material
import Box from "@material-ui/core/Box";
//Component
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import BootstrapTable from 'react-bootstrap-table-next';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import Grid from "@material-ui/core/Grid";
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { MaterialUIDatePickers } from "./../../stories/hook-controls/datepicker/datepicker";
//Function
import * as api from "./api";
import { getColumns } from "./columns/job-schedule";
import { GetUser } from "../../utils/sessions";
import * as alertDialog from "../../utils/alert";
import { useSelectItem } from "../../stories/react-table/useSelectItem";
import { Button } from "@material-ui/core";
import { isEmptyArray } from "../../utils/common-function";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootSearch: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    width: 600,
  },
  rootButton: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    width: 150,
  },
  searchText: {
    textAlign: '-webkit-right'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    // padding: 10,
    backgroundColor: '#000',
    color: '#fff',
  },
  iconButtonActiveInactive: {
    // padding: 10,
    backgroundColor: '#000',
    color: '#fff',
    marginRight: theme.spacing(2),
  },
  divider: {
    height: 28,
    margin: 4,
  },
  searchDate: {
    textAlign: 'left',
    marginTop: theme.spacing(1),
    width: 180,
  },
  textLabelFrom: {
    textalign: 'center',
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    color: '#000',
    width: 50,
  },
  textLabelTo: {
    textalign: 'center',
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    color: '#000',
    width: 50,
  },


}));
function ScheduleMonitor() {
  //State
  const classes = useStyles();
  //State
  const method = useForm();
  const { register, getValues } = method;
  const [DataList, setDataList] = useState([]);
  const [openModalViewHistory, setOpenModalViewHistory] = useState(false);
  const [JobGUID, setJobGUID] = useState();
  const [statusSearch, setStatusSearch] = useState("");
  const { handleOnSelect, handleOnSelectAll, SelectedItems } = useSelectItem(
    "EXEC_NO"
  );

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  //Effect
  useEffect(() => {
  
    fetch();
  }, []);

  const fetch = async () => {
    var newYork    = moment.tz(new Date(), "Asia/Bangkok").format();
    console.log(newYork);
    let param = { "TEXT_SEARCH": "", "DATE_START": GetLocalDateFormat(startDate), "DATE_END": GetLocalDateFormat(endDate) };
    let res = await api.GetListJobScheduleMonitor(param);
    setDataList(res);
  }
  const SearchText = async () => {
    setDataList([]);

    let param = { "TEXT_SEARCH": getValues().TEXT_SEARCH, "DATE_START": GetLocalDateFormat(startDate), "DATE_END": GetLocalDateFormat(endDate) };
    //console.log(param);
    let res = await api.GetListJobScheduleMonitor(param);
    setDataList(res);
    handleOnSelectAll(false);

  }
  const handleChangeStartDate = async (date) => {

    setStartDate(date)
    if (date > endDate) {
      setEndDate(date)
    }
    setDataList([]);
    let param = { "TEXT_SEARCH": getValues().TEXT_SEARCH, "DATE_START": GetLocalDateFormat(date), "DATE_END": date > endDate ? GetLocalDateFormat(date) : GetLocalDateFormat(endDate) };
    //console.log(param);
    let res = await api.GetListJobScheduleMonitor(param);
    setDataList(res);

  }
  const handleChangeEnddate = async (date) => {

    setEndDate(date)
    setDataList([]);
    let param = { "TEXT_SEARCH": getValues().TEXT_SEARCH, "DATE_START":  GetLocalDateFormat(startDate), "DATE_END":  GetLocalDateFormat(date) };
    //console.log(param);
    let res = await api.GetListJobScheduleMonitor(param);
    setDataList(res);


  }
  const GetLocalDateFormat = (pDate) =>{
    return moment.tz(pDate, "Asia/Bangkok").format();
  }

  const onViewHistory = (JobGUID) => {
    setJobGUID(JobGUID);
    setOpenModalViewHistory(true);
  }
  const onCloseViewModalHistory = () => {
    setOpenModalViewHistory(false);
  };

  const handleEnter = (e) => {
    if (e.keyCode === 13) {
      SearchText();
      e.preventDefault();
    }
  }

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Monitor Task">
          <FormProvider {...method}>
            <Grid item xs={12} container spacing={1}>
              <Grid item xs={6} container spacing={1}>
                <InputLabel id="simple-select-outlined-label" className={classes.textLabelFrom} >Date : </InputLabel>
                <MaterialUIDatePickers name="DATE_FROM" label="From" className={classes.searchDate}
                                        format="dd-MMM-yyyy"
                                        variant="dialog"
                                        value={startDate}
                                        onChange={handleChangeStartDate}
                                    />
                {/* <FormControl variant="outlined" className={classes.searchDate}>
                  <DatePicker
                    dateFormat="dd-MMM-yyyy"
                    selected={startDate}
                    onChange={handleChangeStartDate}
                    startDate={startDate}
                  />
                </FormControl> */}
                <InputLabel id="simple-select-outlined-label" className={classes.textLabelTo} >To</InputLabel>
                <MaterialUIDatePickers name="DATE_TO" label="To" className={classes.searchDate}
                                        format="dd-MMM-yyyy"
                                        variant="dialog"
                                        value={endDate}
                                        onChange={handleChangeEnddate}
                                        minDate={startDate}
                                        startdate={startDate}
                                        enddate={endDate}
                                    />
                {/* <FormControl variant="outlined" className={classes.searchDate}>
                  <DatePicker
                    dateFormat="dd-MMM-yyyy"
                    selected={endDate}
                    onChange={handleChangeEnddate}
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                  />
                </FormControl> */}

              </Grid>
              <Grid item xs={6} className={classes.searchText}>
                <Paper component="form" className={classes.rootSearch}>

                  <InputBase
                    className={classes.input}
                    placeholder="Search"
                    inputProps={{ 'aria-label': 'search' }}
                    name="TEXT_SEARCH"
                    inputRef={register}
                    onKeyDown={(e) => handleEnter(e)}
                  />
                  {/* <IconButton type="submit" className={classes.iconButton} aria-label="search">
              <SearchIcon />
            </IconButton> */}
                  <Divider className={classes.divider} orientation="vertical" />
                  <Button variant="contained" className={classes.iconButton} onClick={SearchText}>
                    Search
                  </Button>

                </Paper>

              </Grid>
            </Grid>
            {DataList?.length > 0 ?
              (<ReactTable id="1"
                showSearch={false}
                keyField="EXEC_NO"
                data={DataList}
                clickToSelect={false}
                columns={getColumns()}
              />) : <BootstrapTable keyField='EXEC_NO' data={[]} columns={getColumns()} noDataIndication={'No results found'} />}
          </FormProvider>

        </BoxTemplate1>

      </BaseContainer>
    </div>
  );
}
export default ScheduleMonitor;
